/**
 * Rewrites the original hospital template markup so it can be rendered inside
 * the React SPA:
 *  - relative `assets/...` paths become absolute `/assets/...`
 *  - `.html` links become React Router routes
 *  - out-of-scope template pages fall back to the home route to avoid dead ends
 */
const routeMap: Record<string, string> = {
  'index.html': '/',
  'index-2.html': '/',
  'index-3.html': '/',
  'about.html': '/about',
  'services.html': '/services',
  'services-details.html': '/services',
  'appointment.html': '/appointment',
  'doctor.html': '/doctors',
  'doctor-details.html': '/doctors',
  'portfolio.html': '/portfolio',
  'portfolio-details.html': '/portfolio-details',
  'image-gallery.html': '/image-gallery',
  'video-gallery.html': '/video-gallery',
  'testimonials.html': '/testimonials',
  'faq.html': '/faq',
  'error.html': '/error',
  'sign-in.html': '/sign-in',
  'register.html': '/register',
  'forget-password.html': '/forget-password',
  'blog.html': '/blog',
  'blog-details.html': '/blog',
  'contact.html': '/contact',
  // templates outside the delivered page set — keep the user on a real page
  'pricing.html': '/',
  'shop.html': '/',
  'shop-details.html': '/',
  'cart.html': '/',
  'checkout.html': '/',
  'wishlist.html': '/',
}

export function rewriteTemplateHtml(html: string): string {
  const out = html
    // absolute asset paths (src, data-img-src, poster, css url(...))
    .replace(/(?<!\/)assets\//g, '/assets/')
    // internal .html links -> routes
    .replace(/href="([^"#]*?\.html)(#[^"]*)?"/g, (_match, file: string, hash?: string) => {
      const route = routeMap[file]
      if (!route) return _match
      return `href="${route}${hash ?? ''}"`
    })

  return out
}
